import { Popup } from 'devextreme-react';
import React, { useState } from 'react';
import { useHistory } from 'react-router';
import { useTranslation } from '../../contexts/translation';
import { CustomerAssetsForm } from '../../forms/customerAssets/CustomerAssetsForm';
import { Columns } from '../../pages/CustomerAssets/Columns';
import { SisDataGrid } from '../table';
import { IDataGrid } from './AssetsDataGrid';

interface CustomerAssetsIDataGrid extends IDataGrid {
  customerId: number;
  onAddSuccess: () => void;
}

export const CustomerAssetsDataGrid = ({
  data,
  handleDelete,
  customerId,
  onAddSuccess,
}: CustomerAssetsIDataGrid) => {
  const { translate } = useTranslation();
  const transFormName = 'CustomerAssets.List';
  const history = useHistory();
  const [createModal, setCreateModal] = useState(false);

  const onToolbarPreparing = (e) => {
    e.toolbarOptions.items.unshift(
      {
        location: 'before',
        html: translate!('Assets', transFormName),
      },
      {
        location: 'after',
        widget: 'dxButton',
        options: {
          icon: 'add',
          type: 'default',
          stylingMode: 'contained',
          onClick: () => {
            setCreateModal(true);
          },
        },
      },
    );
  };
  return (
    <>
      <SisDataGrid
        data={data}
        keyExpr={'id'}
        transFormName={transFormName}
        columns={Columns(handleDelete, translate)}
        columnChooser={false}
        allowColumnResizing={false}
        allowColumnReordering={false}
        onToolbarPreparing={onToolbarPreparing}
      />
      {createModal && (
        <Popup
          visible
          dragEnabled={false}
          closeOnOutsideClick
          onHiding={() => setCreateModal(false)}
          showTitle
          title={translate!('Assign asset to customer', transFormName)}
          width={'20%'}
          height={'150px'}
        >
          <CustomerAssetsForm
            customerId={customerId}
            assignedAssets={data}
            onCancel={() => setCreateModal(false)}
            onSuccess={() => {
              setCreateModal(false);
              onAddSuccess();
            }}
            onSubmit={() => undefined}
          />
        </Popup>
      )}
    </>
  );
};
